<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Share report</template>

    <Sheet.Body class="pt-[25px]">
      <ShareReportBody
        :report="report"
        :get-report="getReport"
        :public-url="publicUrl"
      />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'
import type { ReportQuery } from '@/shared/graphql/router/graphql'
import ShareReportBody from './ShareReportBody.vue'

type ShareReport = NonNullable<ReportQuery['report']>

defineProps<{
  report: ShareReport
  getReport?: () => ShareReport | undefined
  publicUrl?: string
}>()

const { close } = useSheet()
</script>
